<div role="alert" class="error-state">
  <span class="error-state-icon">
    <aiwyn-icon name="alert-triangle" [height]="26" [width]="26" />
  </span>
  <span class="h3-500">Failed to load file</span>
  <span class="error-state-message body-400">{{ message() ?? 'There was a problem displaying this file. Try again, or pick a different file.' }}</span>

  <button dataSelector="file-preview-error-retry" type="button" class="error-state-retry" (click)="onRetry()" andButton color="primary">
    Retry
  </button>
</div>
